var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDealroom = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.339,
    d: "M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    d: "M8.85 17.936v-7.257h2.652v7.257zm5.977 0h-2.638V8.063h3.36q2.372 0 3.67 1.216 1.298 1.217 1.28 3.513c0 1.643-.452 2.915-1.36 3.803-.91.888-2.182 1.336-3.843 1.34zm0-2.19h.555a2.15 2.15 0 0 0 1.78-.704 3.4 3.4 0 0 0 .568-2.156 3.13 3.13 0 0 0-.538-2.015 1.99 1.99 0 0 0-1.631-.653h-.734zM5.5 17.936V13.39h2.65v4.546z"
  })));
};
export default SvgDealroom;